import React from 'react';
import { Button } from "primereact/button";
import Webcam from "react-webcam";
import Loader from "../Loader";
import { useTranslation } from 'react-i18next';

const CameraCapture = ({
  webcamRef,
  loading,
  onCapture,
  onCancel,
  title
}) => {
  const { t } = useTranslation();

  const constraints = {
    facingMode: { exact: "environment" }
  };

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <span
        className="color-light text-center fw-medium w-80 mb-4"
        style={{ fontSize: "20px" }}
      >
        {title}
      </span>

      <div
        className="camera-frame-container"
        style={{
          width: "100%",
          maxWidth: "400px",
          height: "240px",
          border: "2px solid #0066FF",
          borderRadius: "12px",
          margin: "20px 0",
          position: "relative",
        }}
      >
        <Webcam
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={constraints}
          disablePictureInPicture={true}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "10px",
          }}
        />

        {loading && <Loader />}
      </div>

      <div
        style={{
          position: "fixed",
          bottom: "20px",
          left: "0",
          right: "0",
          padding: "0 16px",
        }}
      >
        <Button
          label={`${t('common.takePhoto')}`}
          className="btn-primary w-100"
          loading={loading}
          onClick={onCapture}
          size="large"
        />
        <Button
          label={`${t('common.cancel')}`}
          className="p-button-text color-danger w-100"
          onClick={onCancel}
          size="large"
          style={{
            fontWeight: "normal",
          }}
        />
      </div>
    </div>
  );
};

export default CameraCapture;